import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { useCollection } from 'Context/CollectionContext';
import DataContainer from 'Components/UI/DataContainer';
import { TrusteeApprovalOverride } from 'Resources/TrustApproval';

const styles = () => ({
  root: {},
  header: {},
});

const PrimaryTrusteeForm = ({
  classes,
  onSubmit,
}) => {
  const {
    collection,
    isInitializing,
    initializingError,
  } = useCollection();

  const resource = collection?.resources().length() > 0 ? collection?.resources()
    .head() : collection?.create();

  return (
    <DataContainer loading={isInitializing || !collection} loadingError={initializingError}>
      <Box className={classes.root} p={2}>
        {resource !== null && <MetaFormInline resource={resource} onSubmit={onSubmit} metaOverrideSet={TrusteeApprovalOverride} />}
      </Box>
    </DataContainer>
  );
};

PrimaryTrusteeForm.defaultProps = {};

PrimaryTrusteeForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PrimaryTrusteeForm);
